module.exports = __webpack_public_path__ + "static/img/c-b1.55a86d28.png";